import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ActionButtonColor } from './action-button.types';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  @Input() label: string = '';
  @Input() color: ActionButtonColor = 'primary';
  @Input() disabled: boolean = false;
  @Input() isOutlined: boolean = false;
  @Input() endIconName?: string;
  @Input() isLoading?: boolean = false;

  constructor() {}

  @HostBinding('attr.disabled') get hostDisabled() {
    return this.disabled || this.isLoading;
  }
}
